var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTableEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.8,
    r: 12,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 17.4667H8.28333L14.8 10.95L13.85 9.99999L7.33333 16.5167V17.4667ZM6 18.8V15.9667L14.8 7.18332C14.9333 7.0611 15.0806 6.96665 15.2417 6.89999C15.4028 6.83332 15.5722 6.79999 15.75 6.79999C15.9278 6.79999 16.1 6.83332 16.2667 6.89999C16.4333 6.96665 16.5778 7.06665 16.7 7.19999L17.6167 8.13332C17.75 8.25554 17.8472 8.39999 17.9083 8.56665C17.9694 8.73332 18 8.89999 18 9.06665C18 9.24443 17.9694 9.41388 17.9083 9.57499C17.8472 9.7361 17.75 9.88332 17.6167 10.0167L8.83333 18.8H6ZM14.3167 10.4833L13.85 9.99999L14.8 10.95L14.3167 10.4833Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableEdit);
export default __webpack_public_path__ + "static/media/ICON_TABLE_EDIT.6ab6f4bc5d2df887ab61abd63283595d.svg";
export { ForwardRef as ReactComponent };